function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-eye-dropper",
  "data-name": "Icon awesome-eye-dropper",
  d: "M3.037,19.942A3.83,3.83,0,0,0,1.915,22.65v2.722L0,28.723l1.915,1.915,3.351-1.915H7.988A3.83,3.83,0,0,0,10.7,27.6l7.578-7.577-7.66-7.66ZM28.956,1.683a5.743,5.743,0,0,0-8.123,0L16.219,6.3l-.784-.784a1.436,1.436,0,0,0-2.031,0L10.953,7.964a1.436,1.436,0,0,0,0,2.031l9.691,9.691a1.436,1.436,0,0,0,2.031,0l2.452-2.451a1.436,1.436,0,0,0,0-2.031l-.784-.784,4.613-4.613a5.742,5.742,0,0,0,0-8.123Z",
  transform: "translate(0 0)",
  fill: "#1aa0e0"
});

function SvgIconFormulation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.639,
    height: 30.639,
    viewBox: "0 0 30.639 30.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFormulation);
export default __webpack_public_path__ + "static/media/icon-formulation.781670f5.svg";
export { ForwardRef as ReactComponent };